import { createAction } from 'redux-actions';
import {
    SHOW_DTI,
    SHOW_DTI_FAILED,
} from './actionTypes';

export const showDti = createAction(SHOW_DTI);
export const showDtiFailed = createAction(SHOW_DTI_FAILED);
